module.exports = __webpack_public_path__ + "static/little-berries-no-text-edea9f1086e79f7e6accf54461b09908.png";